import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7eeb1c6d"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label", "aria-checked"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: _normalizeClass(["btn", { selected: $props.selected }]),
    style: _normalizeStyle({ color: $props.reason.props?.color }),
    role: "radio",
    "aria-label": $props.reason.name,
    "aria-checked": $props.selected
  }, _toDisplayString($props.reason.name), 15 /* TEXT, CLASS, STYLE, PROPS */, _hoisted_1))
}